import { mergeAttributes, Node } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import AssetImageComponent from '../asset-image'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    assetImage: {
      setAssetImage: (options: { src: string }) => ReturnType
    }
  }
}

export const AssetImage = Node.create({
  name: 'assetImage',

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  group: 'block',

  draggable: true,

  addAttributes() {
    return {
      'data-asset-id': {
        default: null,
        parseHTML: (element) => element.getAttribute('data-asset-id'),
        renderHTML: (attributes) => {
          if (attributes['data-asset-id']) {
            return { 'data-asset-id': attributes['data-asset-id'] }
          }
          return {}
        },
      },
      src: {
        default: null,
        parseHTML: (element) => element.getAttribute('src'),
        renderHTML: (attributes) => {
          if (attributes.src) {
            return { src: attributes.src }
          }
          return {}
        },
      },
      alt: {
        default: null,
      },
      title: {
        default: null,
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'img[data-asset-id]',
      },
      {
        tag: 'img[src]',
        getAttrs: (element) => {
          // Only match images that don't have data-asset-id
          if (typeof element === 'string' || element.hasAttribute('data-asset-id')) {
            return false
          }
          return {}
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]
  },

  addNodeView() {
    return ReactNodeViewRenderer(AssetImageComponent)
  },

  addCommands() {
    return {
      setAssetImage:
        (options) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options.src.includes('/')
              ? { src: options.src } // Direct URL case (Filestack)
              : { 'data-asset-id': options.src }, // Asset ID case (Bytescale)
          })
        },
    }
  },
})
